import { fmt, Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'

import type { TranslationKey } from '#/@types/translate'
import { ImportDateFieldConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

interface IParams {
  dateField?: ImportDateFieldConfig
}

export const buildDateField = ({ dateField }: IParams) => {
  const field = { labelKey: 'date', ...dateField }

  const { hiddenUnless, labelKey, requiredIf, subtractDays } = field

  return {
    label: Translate({ messageKey: labelKey as TranslationKey }),
    name: 'date',
    rules:
      hiddenUnless && requiredIf
        ? {
            hidden_unless: hiddenUnless,
            required_if: {
              field: requiredIf.field,
              message: Translate({
                messageKey: ['required_field', requiredIf.messageKey],
                separator: ' - ',
              }),
              value: requiredIf.value,
            },
          }
        : {
            required: {
              message: Translate({
                messageKey: ['required_field', labelKey],
                separator: ' - ',
              }),
              value: true,
            },
          },
    type: 'date',
    value: Moment()
      .subtract(subtractDays ?? 0, 'day')
      .startOf('d')
      .format(fmt.date),
  }
}
